
import { defineComponent, PropType } from 'vue';
import { B2CLoginTileModel } from '@/types/B2CcontentServerContract';
import LoginForm from '@/b2c/profile/ui/LoginForm.vue';
import BlockMaxWidthHandler from '@/shared/content/blocks/helpers/BlockMaxWidthHandler.vue';

export default defineComponent({
    name: 'B2CLoginTile',
    components: { BlockMaxWidthHandler, LoginForm },
    props: {
        content: {
            type: Object as PropType<B2CLoginTileModel>,
            required: true,
        },
    },
});
